(function () {
  "use strict";

  angular.module("PrintixAPIAdmin", [])

    .constant('LOG_LEVELS', [
      'TRACE', 'DEBUG', 'INFO', 'WARN'
    ])

      .factory('DriversListPaging', ['$rootScope', 'DEFAULT_ITEMS_PER_PAGE', function($rootScope, DEFAULT_ITEMS_PER_PAGE){
          return function() {
            var DriversListPaging = {};
            DriversListPaging.pagingCriteria = {
              page: 0,
              match: null,
              os: null,
              pageSize: DEFAULT_ITEMS_PER_PAGE,
              owned: false,
              sort: 'NAME',
              direction: 'ASC',
              language: null,
              latestVersion: null

            }

            DriversListPaging.getPagedUrlParameters = function() {
              var urlParameters =
                '?page=' + DriversListPaging.pagingCriteria.page +
                '&pageSize=' + DriversListPaging.pagingCriteria.pageSize +
                '&direction=' + DriversListPaging.pagingCriteria.direction +
                '&os=' + DriversListPaging.pagingCriteria.os;

                if (DriversListPaging.pagingCriteria.owned) {
                  urlParameters += '&owned=' + DriversListPaging.pagingCriteria.owned;
                }
                
                if (DriversListPaging.pagingCriteria.sort) {
                  urlParameters += '&sort=' + DriversListPaging.pagingCriteria.sort;
                }

                if (DriversListPaging.pagingCriteria.language) {
                  urlParameters += '&language=' + DriversListPaging.pagingCriteria.language;
                }
                
                if (DriversListPaging.pagingCriteria.latestVersion) {
                  urlParameters += '&latestVersion=' + DriversListPaging.pagingCriteria.latestVersion;
                }
                
                if (DriversListPaging.pagingCriteria.match) {
                  urlParameters += '&match=' + DriversListPaging.pagingCriteria.match;
                }

                if (DriversListPaging.pagingCriteria.owned) {
                  urlParameters += '&owned=' + DriversListPaging.pagingCriteria.owned;
                }

                return urlParameters;
            }

            return DriversListPaging;
          }
        }
      ])

      .factory('AuditEventsListPaging', [function(){
        return function() {
          var AuditEventsListPaging = {};
          AuditEventsListPaging.pagingCriteria = {
            page: 0,
            pageSize: 50,
            startTime: null,
            endTime: null,
            resourceFilter: null,
            logLevel: 'DEBUG',
          }

          AuditEventsListPaging.getPagedUrlParameters = function() {
            var urlParameters = 
              '?page=' + AuditEventsListPaging.pagingCriteria.page +
              '&pageSize='  + AuditEventsListPaging.pagingCriteria.pageSize;

              if (AuditEventsListPaging.pagingCriteria.startTime) {
                urlParameters += '&startTime=' + AuditEventsListPaging.pagingCriteria.startTime;
              }

              if (AuditEventsListPaging.pagingCriteria.endTime) {
                urlParameters += '&endTime=' + AuditEventsListPaging.pagingCriteria.endTime;
              }

              if (AuditEventsListPaging.pagingCriteria.resourceFilter) {
                urlParameters += '&resourceFilter=' + AuditEventsListPaging.pagingCriteria.resourceFilter
              }

              if (AuditEventsListPaging.pagingCriteria.logLevel) {
                urlParameters += '&logLevel=' + AuditEventsListPaging.pagingCriteria.logLevel
              }

            return urlParameters;
          }

          return AuditEventsListPaging;
        }
      }])

      .service("APIAdmin", ["$rootScope", "TenantListService",
          "$http", '$q', 'AuditEventsListPaging',
          function ($rootScope, TenantListService, $http, $q, AuditEventsListPaging) {

              var apiAdminAsObject = this;

              this.getDriversListPaged = function (driverListPagingObject) {
                if (driverListPagingObject && TenantListService.currentTenant && TenantListService.currentTenant.info) {
                  var deferred = $q.defer();
                  $http.get(TenantListService.currentTenant.info._links["px:printerDrivers"].href + driverListPagingObject.getPagedUrlParameters()).then(function(response){
                    deferred.resolve(response);
                  }).catch(function(error){
                    deferred.reject(error);
                  });
                  return deferred.promise;
                } else {
                  throw 'getDriversListPaged is missing either driverListPagingObject or currentTenant';
                }
              };

              //START DRIVERS****************************************************************************************/
              this.getDriverList = function (pageNumber, size, searchString, os, isVerified, showOnlyUploadedPrintDrivers, language, latestVersion) {
                  if (pageNumber > -1 && size > 0 && (searchString || showOnlyUploadedPrintDrivers) && os && typeof isVerified === "boolean") {
                      if (TenantListService.currentTenant) {
                          var urlToUse = angular.copy(TenantListService.currentTenant.info._links["px:printerDrivers"].href);
                          urlToUse += "?page=" + pageNumber +
                              "&size=" + size +
                              "&drivername=" + searchString +
                              "&os=" + os +
                              "&verified=" + isVerified;
                          if (showOnlyUploadedPrintDrivers) {
                              urlToUse+="&owned=true&sort=TENANT_UPLOAD_TIME&direction=DESC";
                          }
                          return $http.get(urlToUse);
                      } else {
                          throw "APIAdmin.getDriverList: TenantListService.currentTenant is missing";
                      }
                  } else {
                      throw "APIAdmin.getDriverList: pageNumber or size or (searchString or showOnlyUploadedPrintDrivers) or os or isVerified are missing";
                  }
              };
              //END DRIVERS******************************************************************************************/


              //START AUDIT******************************************************************************************/
              this.getAuditEvents = function (url, urlSuffix) {
                  if (urlSuffix) {
                      if (TenantListService.currentTenant) {
                          var urlToUse = "";
                          if (url) {
                              urlToUse = url;
                          } else {
                              urlToUse = TenantListService.currentTenant.info._links["px:auditEvents"].href.split("?")[0];
                          }
                          return $http.get(urlToUse + urlSuffix);
                      } else {
                          throw "APIAdmin.getAuditEvents: TenantListService.currentTenant is missing";
                      }
                  } else {
                      throw "APIAdmin.getAuditEvents: urlSuffix is missing";
                  }
              };


              this.getAuditEventsPaged = function(url, auditLogPagingObject) {
                var deferred = $q.defer();
                $http.get(url + auditLogPagingObject.getPagedUrlParameters()).then(function(response) {
                  deferred.resolve(response);
                }).catch(function(error){
                  deferred.reject(error);
                });
                return deferred.promise;
              }
              //END AUDIT********************************************************************************************/


              //START SUPPORT****************************************************************************************/
              this.addSupportTicket = function (url, object) {
                  if (url && object) {
                      return $http.post(url, object);
                  } else {
                      throw "APIAdmin.addSupportTicket: url or object are missing";
                  }
              };
              //END SUPPORT******************************************************************************************/


              //START AUTH TEST**************************************************************************************/
              this.testMSIIdentityConfig = function (url) {
                  if (url) {
                      return $http.get(url);
                  } else {
                      throw "this.testMSIIdentityConfig: url is missing";
                  }
              };
              //END AUTH TEST****************************************************************************************/
          }]);
})();